import React, { useContext } from 'react';
import { ActualIconProps } from 'mobx/commonTypes';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';

export default function IconThunderHail({
  style,
  extColor,
  isAutoscallable = true,
  sizeKey = '32x32',
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      width={w}
      height={h}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.4746 10.4401C22.4227 10.4401 22.3727 10.4473 22.3221 10.4473C21.744 8.01211 19.5633 6.19971 16.9506 6.19971C14.207 6.19971 11.9375 8.2015 11.5061 10.8235C11.1635 10.7268 10.8051 10.6735 10.4309 10.6735C8.53103 10.6735 6.9455 12 6.53909 13.7769C5.05351 14.3595 4 15.8023 4 17.4937C4 19.7007 5.78808 21.4901 7.99573 21.4901H22.4746C25.5267 21.4901 28 19.0181 28 15.9661C28 12.9141 25.526 10.4407 22.4746 10.4407V10.4401ZM15.3039 19.2838L16.6678 14.7712H14.4155L15.7794 9.85741H18.2685L17.2011 13.0193H19.9888L15.3032 19.2845L15.3039 19.2838Z"
        fill="white"
      />
      <rect x="10" y="25" width="3" height="3" fill="white" />
      <rect x="15" y="26" width="3" height="3" fill="white" />
      <rect x="20" y="25" width="3" height="3" fill="white" />
    </svg>
  );
}
